// Meses ENE-DIC (id 1..12) para el picker de meses del modal.
// Los ids reales de la API los resolvemos on-demand en el useEffect; aquí solo
// mantenemos la etiqueta corta y la posición 1..12 para renderizar el grid.
export const MONTHS = [
  { number: 1, short: 'ENE', full: 'Enero' },
  { number: 2, short: 'FEB', full: 'Febrero' },
  { number: 3, short: 'MAR', full: 'Marzo' },
  { number: 4, short: 'ABR', full: 'Abril' },
  { number: 5, short: 'MAY', full: 'Mayo' },
  { number: 6, short: 'JUN', full: 'Junio' },
  { number: 7, short: 'JUL', full: 'Julio' },
  { number: 8, short: 'AGO', full: 'Agosto' },
  { number: 9, short: 'SEP', full: 'Septiembre' },
  { number: 10, short: 'OCT', full: 'Octubre' },
  { number: 11, short: 'NOV', full: 'Noviembre' },
  { number: 12, short: 'DIC', full: 'Diciembre' },
];

// Códigos que devuelve el backend en el batch. La copia va en español para el
// summary; el backend ya trae message pero preferimos textos consistentes.
export const CODE_COPY = {
  ENROLLMENT_NOT_FOUND: 'La matrícula ya no existe',
  ENROLLMENT_INACTIVE: 'La matrícula está retirada',
  STUDENT_MISMATCH: 'La matrícula es de otro estudiante',
  PROGRAM_MISMATCH: 'La matrícula es de otro programa',
  ORDINAL_OUT_OF_RANGE: 'La materia está fuera de rango',
  ORDINAL_CONFLICT: 'Otro pago ya tomó esa materia',
  MONTH_INVALID: 'Meses inválidos',
  MISSING_SUBJECTS_OR_MONTHS: 'Falta seleccionar materias o meses',
  INVALID_INPUT: 'Datos inválidos',
  INTERNAL: 'Error interno',
};

export const STATUS_LABEL = {
  registrado: 'Registrada',
  estudiando: 'Activa',
  promocion_pendiente: 'Promoción Pendiente',
  promovido: 'Promovida',
  graduado: 'Graduada',
  retirado: 'Retirada',
  desercion: 'Deserción',
  aplazado: 'Aplazada',
  no_aprobado: 'No Aprobado',
};
